// Textes de l’interface en français. Repli : es.
export default {
  common: {
    close: "Fermer",
    retry: "Réessayer",
    cancel: "Annuler",
    reset: "Réinitialiser",
    change: "Changer",
  },
  roles: {
    teacher: "Enseignant",
    moderator: "Modérateur",
    student: "Étudiant",
  },
  controlBar: {
    micDisabledByTeacher: "Micro désactivé par l'enseignant",
    micOn: "Activer le micro",
    micOff: "Couper le micro",
    micSettings: "Réglages du micro",
    camDisabledByTeacher: "Caméra désactivée par l'enseignant",
    noCamera: "Aucune caméra détectée",
    camOn: "Activer la caméra",
    camOff: "Désactiver la caméra",
    camSettings: "Réglages de la caméra",
    screenUnsupported: "Votre navigateur mobile ne permet pas le partage d'écran",
    screenDisabledByTeacher: "Partage d'écran désactivé par l'enseignant",
    screenShare: "Partager l'écran",
    screenStop: "Arrêter le partage d'écran",
    screenSwitch: "Changer d'écran partagé",
    captionOptions: "Langue et taille des sous-titres",    captionsReadIn: "Je lis les sous-titres en",
    captionsHint: "Ne change que {you} : ce qui se dit en classe vous arrive traduit dans cette langue. Chacun choisit la sienne.",
    captionsHintYou: "votre écran",
    captionsSpeakIn: "Je parle en",
    captionsSpeakHint: "C'est ainsi que {mic} est transcrit. Votre voix seulement : chacun indique la sienne.",
    captionsSpeakHintMic: "votre micro",
    captionSize: "Taille des sous-titres",
    captionsOn: "Activer les sous-titres en direct",
    captionsOff: "Désactiver les sous-titres en direct",
    captionsHide: "Masquer les sous-titres",
    captionsShow: "Afficher les sous-titres",
    leave: "Quitter la session",
    more: "Plus d'options",
  },
  captions: {
    untranslated: "Pas encore traduit · {lang}",
    size: {
      sm: "Petit",
      md: "Moyen",
      lg: "Grand",
      xl: "Très grand",
    },
  },
  sessionMenu: {
    title: "Menu de la session",
    section: "Session",
    code: "Code",
    codeHide: "Masquer le code",
    codeShow: "Afficher le code",
    copyInvite: "Copier le lien d'invitation",
    recordStart: "Enregistrer la session",
    recordStop: "Arrêter l'enregistrement ({duration})",
    recordPause: "Mettre l'enregistrement en pause",
    recordResume: "Reprendre l'enregistrement",
    recordPauseHint: "Ce qui est en pause n'est pas enregistré",
    recordPausedHint: "En pause : aucun enregistrement",
    subtitles: "Sous-titres automatiques",
    subtitlesOn: "Un fichier .vtt sera généré à l'arrêt",
    subtitlesOff: "Désactivés",
    fullscreen: "Plein écran",
    fullscreenExit: "Quitter le plein écran",
    endSession: "Terminer la session",
    endSessionHint: "Le cours se termine pour tout le monde",
    endSessionConfirm: "Le cours se termine pour tout le monde et la salle est fermée. Pour la rouvrir, il faut modifier l'horaire de l'activité.",
    endSessionCancel: "Annuler",
    endSessionConfirmYes: "Terminer",
  },
  sidePanel: {
    title: "Panneau de la session",
    open: "Ouvrir le panneau de la session",
    close: "Fermer le panneau",
    back: "Retour",
    tabs: {
      chat: "Chat",
      attendees: "Participants",
      transcript: "Transcription",
      share: "Partager du contenu",
      settings: "Mes réglages",
    },
  },
  transcript: {
    note: "En {lang}, votre langue de lecture.",
    copy: "Copier",
    copyTitle: "Copier la transcription",
    copied: "Copiée",
    emptyOff: "Les sous-titres en direct sont désactivés. Dès qu'un modérateur les active, tout ce qui se dit apparaît ici.",
    emptyIdle: "Rien n'a encore été dit. Les phrases apparaîtront ici au fur et à mesure.",
    jumpToLatest: "Aller au plus récent",
  },
  hand: {
    chatMicBlocked: "🔒 {by} a bloqué le micro de {name}",
    chatMicAllowed: "🔓 {by} a autorisé le micro de {name}",
    chatCamBlocked: "🔒 {by} a bloqué la caméra de {name}",
    chatScreenBlocked: "🔒 {by} a bloqué le partage d'écran de {name}",
    chatCamAllowed: "🔓 {by} a autorisé la caméra de {name}",
    chatScreenAllowed: "🔓 {by} a autorisé le partage d'écran de {name}",
    chatExpelled: "⛔ {by} a expulsé à {name}",
    chatGranted: "🎤 {by} a donné la parole à {name}",
    chatRevoked: "🔇 {by} a retiré la parole à {name}",
    chatCamGranted: "📷 {by} a activé la caméra de {name}",
    chatCamRevoked: "🚫 {by} a désactivé la caméra de {name}",
    grantCam: "Activer sa caméra",
    revokeCam: "Désactiver sa caméra",
    camGranted: "L'enseignant a activé votre caméra : vous pouvez l'allumer.",
    camTaken: "L'enseignant a désactivé votre caméra.",
    raise_: "Lever la main",
    lower: "Baisser la main",
    chatRaised: "✋ {name} a levé la main",
    notifyRaised: "✋ {name} a levé la main",
    grant: "Donner la parole",
    revoke: "Retirer la parole",
    lowerFor: "Baisser sa main",
    options: "Voir dans les participants",
    gone: "N'est plus dans la salle",
    youHaveTheFloor: "Vous avez la parole : activez votre micro pour parler.",
    floorTaken: "Votre tour de parole est terminé.",
    raisedYou: "Vous avez levé la main. Le modérateur vous donnera la parole.",
    loweredYou: "Vous avez baissé la main.",
    hasFloor: "A la parole",
    raisedBadge: "Main levée",
    raisedCount: "{n} main(s) levée(s)",
  },
  chat: {
    title: "Chat de la réunion",
    emptyTitle: "Les messages apparaîtront ici",
    emptyHint: "Soyez le premier à en envoyer un",
    placeholder: "Envoyer un message à tout le monde",
    hint: "Entrée pour envoyer, Maj+Entrée pour une nouvelle ligne",
    roleTeacher: "PROF",
    roleModerator: "MOD",
  },
  share: {
    screenStart: "Partager l'écran",
    screenStop: "Arrêter le partage d'écran",
    screenUnsupported: "Non disponible dans ce navigateur",
    disabledByTeacher: "Désactivé par l'enseignant",
    screenSwitch: "Changer d'écran partagé",
    screenSwitchHint: "Choisissez une autre fenêtre ou un autre onglet",
    pdfStart: "Présenter un PDF",
    pdfStop: "Arrêter la présentation PDF",
    pdfHint: "Partagez un document page par page",
    empty: "Vous n'avez rien à partager dans cette session.",
  },
  participants: {
    lockedNote: "Les autorisations grisées viennent des paramètres de la session dans Moodle et ne peuvent être modifiées que là.",
    setInMoodle: "Se modifie dans les paramètres de la session dans Moodle",
    title: "Participants",
    classroomControls: "Commandes de la classe",
    muteOnJoin: "Couper le micro à l'arrivée",
    allowStudentVideo: "Autoriser les caméras des étudiants",
    allowStudentAudio: "Autoriser les micros des étudiants",
    allowScreenShare: "Autoriser le partage d'écran",
    allowChat: "Autoriser le chat",
    allowRecording: "Autoriser l'enregistrement",
    muteAll: "Couper tous les micros",
    camerasOff: "Éteindre les caméras",
    search: "Rechercher un participant",
    you: "Vous",
    group: {
      teacher: "Enseignants",
      moderator: "Modérateurs",
      hands: "Tour de parole",
      student: "Étudiants",
    },
    micAllow: "Autoriser le micro",
    micBlock: "Bloquer le micro",
    camAllow: "Autoriser la caméra",
    screenAllow: "Autoriser le partage d'écran",
    camBlock: "Bloquer la caméra",
    screenBlock: "Bloquer le partage d'écran",
    makeModerator: "Nommer modérateur",
    makeTeacher: "Nommer enseignant",
    expel: "Exclure le participant",
    empty: "Aucun participant trouvé",
  },
  settings: {
    language: "Langue de l'interface",
    microphone: "Micro",
    micUnnamed: "Micro sans nom",
    noMics: "Aucun micro détecté",
    audioSettings: "Réglages audio",
    volume: "Volume",
    noiseSuppression: "Suppression du bruit",
    advanced: "Réglages avancés",
    agc: "Amplifier le micro (AGC)",
    agcHint: "Égalise votre voix à la source pour que tout le monde vous entende au même niveau (comme sur Discord). Activé par défaut ; désactivez-le seulement s'il amplifie trop les bruits de fond.",
    normalize: "Normaliser le volume des autres",
    normalizeHint: "Normalement inutile : chaque micro s'égalise déjà à la source. Activez-le seulement si une personne précise s'entend encore trop fort ou trop bas.",
    peakLimit: "Limite des crêtes",
    off: "désactivé",
    micTest: "Tester le micro",
    micTestStop: "Arrêter le test",
    micLevel: "Niveau du micro",
    micTestPrivate: "Pendant le test, personne d’autre ne vous entend.",
    camera: "Caméra",
    camUnnamed: "Caméra sans nom",
    noCams: "Aucune caméra détectée",
    videoFilters: "Filtres vidéo",
    filterQuality: "Qualité du filtre",
    filterQualityLabel: "Qualité du filtre : {level}",
    mirrorOn: "Activer le miroir",
    mirrorOff: "Désactiver le miroir",
    mirrorHint: "Inverse votre caméra horizontalement",
    bgImage: "Image de fond",
    bgImageRemove: "Retirer l'image de fond",
    bgImageHint: "S'applique avec Supprimer le fond, Flouter le fond ou Chroma",
    pipRounded: "Arrondir les bords du PiP",
    pipSquare: "Supprimer les bords arrondis du PiP",
    pipHint: "Coins arrondis sur la caméra",
    chat: "Chat",
    chatMute: "Masquer les notifications de messages",
    chatMuteHint: "Ni son ni notifications pour les nouveaux messages",
    teacherMode: "Mode Enseignant",
    overlayMode: "Mode superposition",
    overlayHint: "Place votre caméra par-dessus l'écran partagé",
  },
  filters: {
    title: "Filtres vidéo",
    open: "Ouvrir les filtres",
    close: "Fermer les filtres",
    none: {
      name: "Aucun filtre",
      description: "La vidéo d'origine, sans effets",
    },
    backgroundRemoval: {
      name: "Supprimer le fond",
      description: "Supprime le fond et ne garde que votre silhouette",
    },
    backgroundBlur: {
      name: "Flouter le fond",
      description: "Floute le fond en gardant la personne nette",
    },
    chromaGreen: {
      name: "Fond vert (chroma key)",
      description: "Découpe les pixels verts (fond vert)",
    },
    quality: {
      basic: {
        name: "Basique",
        description: "15 fps · léger (CPU faible)",
      },
      medium: {
        name: "Moyen",
        description: "20 fps · équilibré",
      },
      high: {
        name: "Élevé",
        description: "30 fps · fluide",
      },
      max: {
        name: "Maximum",
        description: "30 fps · modèle le plus précis",
      },
    },
  },
  grid: {
    moreParticipants: "participants",
    participantGone: "Déconnecté",
    netLost: "Connexion perdue",
    netWeak: "Connexion faible",
    netNone: "Pas de connexion",
    micMuted: "Micro coupé",
    camOff: "Caméra désactivée",
    screenOf: "Écran de {name}",
    yourScreen: "Votre écran",
  },
  audioMenu: {
    subtitle: "Régler le volume",
    noAudio: "Ce participant n'a pas d'audio disponible.",
    screen: "Écran partagé",
    mic: "Micro",
    autoNormalize: "Normalisation automatique",
    auto: "Auto",
  },
  overlay: {
    drag: "Faites glisser pour déplacer",
    position: "Changer de position",
    hide: "Masquer la superposition",
  },
  pdf: {
    title: "Présentation PDF",
    whiteboard: "Tableau blanc",
    maximize: "Agrandir",
    restore: "Restaurer la taille",
    color: "Couleur",
    width: "Épaisseur",
    fill: "Remplir les formes",
    undo: "Annuler (Ctrl+Z)",
    redo: "Rétablir (Ctrl+Y)",
    clear: "Effacer le canevas",
    deleteSelected: "Supprimer l'élément sélectionné (Suppr)",
    change: "Changer de PDF",
    changeCurrent: "Changer de PDF (actuel : {file})",
    load: "Charger un PDF",
    loading: "Chargement du PDF...",
    loadError: "Impossible de charger le PDF",
    emptyHint: "Chargez un PDF pour commencer.",
    whiteboardHintA: "Dessinez librement sur le canevas principal.",
    whiteboardHintB: "Les étudiants ne voient que ce qui est à l'écran, votre caméra comprise.",
    prevPage: "Page précédente",
    nextPage: "Page suivante",
    rendering: "Rendu de la page...",
    zoomIn: "Zoomer",
    zoomOut: "Dézoomer",
    zoomReset: "Réinitialiser le zoom (100 %)",
    panHint: "Maintenez Ctrl et faites glisser pour déplacer la vue",
    tools: {
      select: "Sélectionner",
      pen: "Crayon",
      line: "Ligne",
      rect: "Rectangle",
      circle: "Cercle",
      text: "Texte",
      eraser: "Gomme",
    },
    textPrompt: "Texte :",
  },
  room: {
    callTime: "Temps en appel",
    latency: "Latence de votre connexion (aller-retour)",
    connectionError: "Erreur de connexion",
    recTitle: "Cette session est en cours d'enregistrement",
    recPausedTitle: "Enregistrement en pause : rien n'est enregistré",
    recPausedBadge: "PAUSE",
    netPoor: "Connexion faible",
    netUnstable: "Connexion instable",
    noMediaAccess: {
      camera: "Pas d'accès à la caméra — vérifiez les autorisations du navigateur",
      mic: "Pas d'accès au micro — vérifiez les autorisations du navigateur",
      both: "Pas d'accès à la caméra ni au micro — vérifiez les autorisations du navigateur",
    },
    connecting: "Connexion...",
    reconnecting: "Reconnexion...",
    reconnectAttempt: "Tentative {n}",
    connectionLost: "Connexion perdue",
    reconnectFailed: "Reconnexion automatique impossible. Vérifiez votre connexion Internet et appuyez sur le bouton.",
    reconnect: "Se reconnecter",
    recordingInProgress: "Un enregistrement est en cours ({duration}).",
    saveRecording: "Enregistrer la capture",
    confirmLeave: "Voulez-vous vraiment quitter la réunion ?",
    unloadWarning: "L'enregistrement est toujours en cours. Arrêtez-le avant de partir.",
    route: {
      turn: "Trafic relayé par un serveur TURN (réseau restrictif)",
      stun: "Connexion directe entre pairs (découverte via STUN)",
      direct: "Connexion directe sur le même réseau local",
      directLabel: "Direct",
      pending: "Détermination de la route de connexion…",
    },
    notify: {
      captionsMicBlocked: "Votre voix n'est pas encore transcrite : cliquez n'importe où sur l'écran pour l'activer.",
      captionsOn: "Sous-titres en direct activés. Choisissez votre langue et leur taille dans le bouton des sous-titres de la barre du bas ; tout ce qui a été dit est dans l'onglet Transcription.",
      captionsOff: "Sous-titres en direct désactivés.",
      serverRecDone: "Enregistrement terminé. Il sera importable dans Moodle d'ici quelques minutes.",
      serverRecDoneLocal: "Enregistrement terminé. Il est en cours de téléchargement sur votre ordinateur.",
      recDownloading: "Enregistrement prêt : téléchargement sur votre ordinateur…",
      recDownloadingParts: "Enregistrement prêt en {n} parties : téléchargement sur votre ordinateur…",
      lostButRecording: "Connexion à la salle perdue. L'enregistrement local continue.",
      subtitlesGenerating: "Génération des sous-titres de l'enregistrement…",
      subtitlesFailed: "Impossible de générer les sous-titres",
      subtitleModel: "Chargement du modèle de sous-titrage…",
      subtitleModelPct: "Chargement du modèle de sous-titrage… {pct}%",
      recUnsupported: "Votre navigateur ne peut pas enregistrer le cours. Utilisez Chrome, Edge ou un autre navigateur basé sur Chromium.",
      connectError: "Échec de la connexion",
      micMuted: "Micro coupé",
      micOn: "Micro activé",
      audioError: "Impossible de modifier l'audio",
      camOn: "Caméra activée",
      camOff: "Caméra désactivée",
      videoError: "Impossible de modifier la vidéo",
      screenOn: "Partage d'écran en cours",
      screenOff: "Partage d'écran arrêté",
      screenError: "Impossible de partager l'écran",
      screenSwitched: "Écran partagé mis à jour",
      screenSwitchError: "Impossible de changer d'écran partagé",
      filterUnavailable: "Le filtre n'a pas pu se charger (modèle d'IA indisponible). Vérifiez la connexion ou les restrictions du navigateur (CSP / bloqueur de pub). Détails dans la console.",
      filterError: "Impossible d'appliquer le filtre",
      pdfError: "Impossible de lancer la présentation PDF",
      micSwitched: "Micro changé",
      micSwitchError: "Impossible de changer de micro",
      camSwitched: "Caméra changée",
      camSwitchError: "Impossible de changer de caméra",
      recSaved: "Enregistrement sauvegardé. Téléchargement du fichier...",
      recSaveError: "Impossible de sauvegarder l'enregistrement",
      recStoppedLocal: "Enregistrement arrêté. Téléchargement du fichier…",
      recStartedLocal: "Enregistrement local démarré",
      recStartError: "Impossible de démarrer l'enregistrement",
      recMergePending: "L'enregistrement est sauvegardé mais n'a pas encore pu être assemblé ; nouvelle tentative automatique",
      recStopping: "Arrêt de l'enregistrement…",
      recStoppedServer: "Enregistrement arrêté. Le serveur traite la vidéo, les sous-titres et le chat : vous pouvez fermer la fenêtre.",
      recStopError: "Impossible de confirmer l'arrêt de l'enregistrement. Il est peut-être toujours en cours — réessayez.",
      endSessionError: "Impossible de confirmer la fermeture de la session. Elle est peut-être encore ouverte — réessayez.",
      recStartedServer: "Enregistrement de la salle démarré",
      recStarting: "Démarrage de l'enregistrement de la salle…",
      recServerBusy: "Impossible d'enregistrer : le serveur d'enregistrement est à pleine capacité car d'autres salles enregistrent. Réessayez dans quelques minutes.",
      recResumed: "Enregistrement repris",
      recPaused: "Enregistrement en pause. Appuyez sur Reprendre l'enregistrement pour continuer dans le même fichier.",
      participantMicBlocked: "Micro bloqué pour le participant",
      participantMicAllowed: "Le participant peut de nouveau activer son micro",
      participantCamBlocked: "Caméra bloquée pour le participant",
      participantScreenBlocked: "Partage d'écran bloqué pour le participant",
      participantCamAllowed: "Le participant peut de nouveau activer sa caméra",
      participantScreenAllowed: "Le participant peut de nouveau partager son écran",
      expelling: "Exclusion du participant...",
      settingError: "Impossible de mettre à jour le réglage",
      settingUpdated: "Réglages mis à jour",
      allMuted: "Tous les étudiants ont été mis en sourdine",
      allCamsOff: "Toutes les caméras des étudiants ont été désactivées",
      linkCopied: "Lien d'invitation copié",
      linkCopyError: "Impossible de copier le lien",
    },
  },
  notify: {
    joinedAs: "Vous avez rejoint en tant que {name}",
    reconnected: "Connexion rétablie",
    reconnectFailed: "Reconnexion impossible. Vérifiez votre connexion Internet.",
    beingRecorded: "Cette session est en cours d'enregistrement.",
    roleNotGranted: "Vous êtes entré comme étudiant : votre lien d'accès n'atteste pas le rôle d'enseignant. Prévenez l'administrateur du campus.",
    roomDataError: "Impossible de traiter les données de la salle",
    participantJoined: "{name} a rejoint",
    participantLeft: "{name} est parti",
    recordingStarted: "L'enregistrement de la session a commencé.",
    recordingStopped: "Enregistrement arrêté",
    recordingPaused: "Enregistrement en pause : rien n'est enregistré à partir de maintenant.",
    recordingResumed: "Enregistrement repris.",
    participantExpelled: "{name} a été exclu",
    forcedMicOff: "Le modérateur a coupé votre micro",
    forcedCamOff: "Le modérateur a désactivé votre caméra",
    forcedScreenOff: "Le modérateur a arrêté votre partage d'écran",
    forcedMicBlocked: "Le modérateur a bloqué votre micro",
    forcedMicAllowed: "Le modérateur vous autorise de nouveau le micro : activez-le quand vous voulez",
    forcedCamBlocked: "Le modérateur a bloqué votre caméra",
    cameraUnusable: "Cette caméra ne fonctionne pas sur cet appareil ; elle a été retirée de la liste",
    forcedScreenBlocked: "Le modérateur a bloqué votre partage d'écran",
    forcedCamAllowed: "Le modérateur vous autorise de nouveau la caméra : activez-la quand vous voulez",
    forcedScreenAllowed: "Le modérateur vous autorise de nouveau le partage d'écran",
    youWereExpelled: "Vous avez été exclu de la salle : {reason}",
    mutedAllBy: "{by} a mis en sourdine tous les étudiants",
    camsOffAllBy: "{by} a désactivé toutes les caméras des étudiants",
    settingsUpdatedBy: "{by} a mis à jour les réglages de la salle",
    youAreNow: "Vous êtes maintenant {role}",
    meshMode: "Vous êtes en mode compatibilité (maillage) : vous risquez de ne pas voir ni entendre les autres. Rechargez la page en retirant « ?sfu=0 » de l'adresse.",
    sfuReconnecting: "Reconnexion au serveur vidéo…",
    sfuLost: "Connexion au serveur vidéo perdue. Nouvelle tentative…",
    sfuDown: "Le serveur vidéo ne répond pas. Nouvelle tentative en cours ; vous ne verrez ni n'entendrez personne avant son retour.",
    sfuDownDev: "Le serveur vidéo de test est éteint : démarrez-le avec « dev.bat up ». La salle se connectera d'elle-même.",
    screenNotAllowed: "L'enseignant n'autorise pas le partage d'écran",
  },
  supervisor: {
    hiddenBanner: "Vous êtes masqué en tant que superviseur : personne ne vous voit ni ne vous entend.",
    reveal: "Me montrer",
    revealed: "Vous êtes maintenant visible pour la salle",
  },
  join: {
    otherRoomTitle: "Vous êtes déjà dans une autre session : {room}",
    otherRoomHint: "Quittez cette session pour rejoindre celle-ci. Dès que vous l'aurez quittée, vous pourrez entrer d'ici.",
    supervisorNotice: "Vous entrez en tant que superviseur : personne ne vous verra ni ne vous entendra tant que vous ne déciderez pas de vous montrer.",
    sfuDownTitle: "Le serveur vidéo ne répond pas",
    sfuDownHint: "Vous pouvez entrer, mais vous ne verrez ni n'entendrez personne avant son retour. Réessayez dans quelques minutes.",
    sfuDownDevHint: "Les VM de test sont éteintes : « dev.bat up » puis patientez quelques minutes. Cet avis disparaît tout seul.",
    loadingRoom: "Chargement de la salle…",
    classroomNotice: "Classe virtuelle : vous entrerez avec le micro et la caméra désactivés. Pour intervenir, levez la main et l’enseignant les activera.",
    lockedByClassroom: "Désactivé dans la classe virtuelle jusqu’à ce que l’enseignant l’active",
    title: "Prêt à rejoindre ?",
    subtitle: "Vérifiez votre audio et votre vidéo avant d'entrer",
    roomCode: "Code de la réunion",
    roomCodePlaceholder: "Saisissez un code",
    yourName: "Votre nom",
    yourNamePlaceholder: "Saisissez votre nom",
    mediaWarning: "Impossible d'accéder à la caméra ou au micro",
    mediaWarningHint: "Vous pouvez rejoindre quand même, ou réessayer",
    cameraFilter: "Filtre de caméra",
    mirror: "Mode miroir",
    join: "Rejoindre maintenant",
    joining: "Connexion...",
    errorRoomRequired: "Le code de la salle est obligatoire",
    errorNameRequired: "Le nom est obligatoire",
    errorGeneric: "Impossible de rejoindre la salle",
  },
  home: {
    heroTitle: "Des cours en direct,{break}sans {highlight}.",
    heroTitleHighlight: "complications",
    heroSubtitle: "Plateforme éducative de diffusion en {hd}, avec tableau blanc collaboratif et transcription par IA. Sans paiement, sans inscription, sans complications. Simplifiez-vous la vie.",
    heroSubtitleHd: "haute définition",
    heroLive: "En direct",
    create: "Créer un cours",
    join: "Rejoindre un cours",
    featureHd: "Vidéo en HD",
    featureHdTip: "Haute Définition",
    featureHdDesc: "Diffusion vidéo en haute définition avec WebRTC pair à pair",
    featureBoard: "Tableau blanc collaboratif",
    featureBoardDesc: "Dessin et collaboration en temps réel à plusieurs",
    featureAi: "Transcription par IA",
    featureAiDesc: "Transcription automatique et analyse de contenu par ML",
    featureRecording: "Enregistrement d'écran",
    featureRecordingDesc: "Enregistrez facilement l'écran ou la caméra de l'enseignant pendant le cours",
    featureChat: "Chat en direct",
    featureChatDesc: "Messagerie instantanée avec historique persistant",
    featureBreakout: "Salles de travail",
    featureBreakoutDesc: "Salles séparées pour le travail en petits groupes",
  },
  create: {
    title: "Créer un nouveau cours",
    subtitle: "Configurez votre nouvelle session vidéo",
    roomName: "Nom du cours",
    roomNamePlaceholder: "ex. Mathématiques avancées",
    roomType: "Type de session",
    types: {
      classroom: "Classe virtuelle",
      meeting: "Réunion",
      webinar: "Webinaire",
      recording: "Enregistrement",
    },
    maxParticipants: "Nombre maximal de participants",
    teacherNamePlaceholder: "Nom de l'enseignant",
    settings: "Réglages du cours",
    submit: "Créer le cours",
    creating: "Création...",
    error: "Impossible de créer le cours",
    cardNumber: "N°",
    chooseOne: "choisissez-en un",
    tickAll: "cochez ce qui convient",
  },
  pip: {
    close: "Fermer la petite vue",
  },
  sessionEnded: {
    title: "Session terminée",
    lead: "Vous avez quitté la session. Vous pouvez la rejoindre à nouveau ou fermer cette fenêtre.",
    leadRemoved: "Un modérateur vous a retiré de la session. Vous pouvez fermer cette fenêtre.",
    titleClosed: "Cette session est terminée",
    titleFinished: "Le cours est terminé",
    leadFinished: "La personne qui animait la session y a mis fin. Vous pouvez fermer cette fenêtre.",
    titleNotOpen: "Cette session n'a pas encore commencé",
    leadClosed: "La session s'est terminée à l'heure prévue et ne peut plus être rejointe. Si vous pensez qu'elle est toujours en cours, prévenez la personne qui l'anime.",
    leadNotOpen: "Vous ne pouvez pas encore entrer : la salle ouvre peu avant l'heure de début. Rouvrez-la depuis le campus au moment du début.",
    titleTimeLimit: "Votre connexion a été fermée",
    leadTimeLimit: "Vous étiez dans la salle depuis 12 heures d'affilée, et la connexion se ferme automatiquement au-delà. Si vous êtes toujours en cours, rejoignez-la à nouveau.",
    rejoin: "Rejoindre à nouveau",
    close: "Fermer la fenêtre",
    closeHint: "Votre navigateur ne ferme pas cet onglet automatiquement : fermez-le vous-même.",
  },
}
